import React, { useContext} from "react";
import { DataContext } from "../../Context/DataContext";
import NoData from "../../NewComponents/NoData";
import { firestore, searchClientAlgolia } from "../../firebase.config";
import { InstantSearch } from "react-instantsearch-hooks-web";
import AccountInvoicesComponent from "./InvoicesComponent";
import { getDiscount, getTotal } from "../../Data/Functions";
import Loader from "../../NewComponents/Loader";

const AccountInvoices = ({windowSize}) => {
  const { userData } = useContext(DataContext);
  
  if(!userData){
    return <div className="container mx-auto w-full h-dvh flex items-center justify-center">
      <Loader />
    </div>
  }

//   const onClickTest = () => {
//     let number = 26057;

//     firestore.collection("orders").where("userID", "==", "TRd25g0VdldPgTumBMkfaw0FGBJ3").where("timestamp", ">", 1731370586006).orderBy("timestamp", "asc").get().then(qSnap => {
//       console.log("running")
//       if(qSnap.empty){
//         console.log("no order")
//         return;
//       }

//       const orders = qSnap.docs.map(doc => ({...doc.data(), id: doc.id}));

//       // const filtered = orders.filter(o => !o.orderInvoiceId)

//       console.log(orders.length)

//       orders.forEach((o,i)=> {
//         console.log(i, o.id)
//         firestore.collection("orders").doc(o.id).update({paypalOrderID: "pay-later"})
//         //  genrateSingleInvoice(number + 3, o, o.id);
//         //  number += 3
//         firestore.collection("orderInvoices").doc(o.orderInvoiceId).update({status: "pay-later", paymentId: "pay-later"})
//       })

//     })
//   }

//   const genrateSingleInvoice = (invoiceNumber, orderData, orderId) => {

//     const invoiceData = {
//         name: orderData.name,
//         invoiceNumber: invoiceNumber,
//         email: orderData.email,
//         paymentId: "paid",
//         status : "paid",
//         teamId: orderData.teamId ? orderData.teamId : null,
//         orders: [{number: orderData.orderNumber, id: orderId}],
//         type: "singleInvoice",
//         clientFirstName: orderData.clientFirstName || "",
//         clientLastName: orderData.clientLastName || "",
//         timestamp: orderData.timestamp,
//         userID: orderData.userID,
//         totalPrice: getTotal(orderData) - getDiscount(orderData),
//     }

//     firestore.collection("teams").doc(orderData.teamId).get().then((teamDoc) => {
//         if(teamDoc.exists){
//             const teamData = teamDoc.data();
//             firestore.collection("orderInvoices").add({...invoiceData, teamName: teamData.name}).catch(e => console.log(e.message));
//         }
//         return true;
//     }).catch(e => console.log(e.message));

// }


  return (
  <>
    <InstantSearch searchClient={searchClientAlgolia} indexName="orderInvoices" >
    {/* <button onClick={onClickTest}>Genrate Auto Invoice Test</button> */}

      <AccountInvoicesComponent windowSize={windowSize}/>
    </InstantSearch>
  </>
);
};

export default AccountInvoices;
